var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-card-collection-btn-component" }, [
    _c(
      "button",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: _vm.$t("FEED.ATTACH_CARD"),
            expression: "$t('FEED.ATTACH_CARD')"
          }
        ],
        staticClass: "btn__reset",
        on: { click: _vm.handleClick }
      },
      [
        _c("img", {
          attrs: { src: require("@assets/imgs/events/search-bar-note.svg") }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }